import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import '@/router/progressControl'
import utm from '@/assets/script/generalEvents'
import {
  Row,
  Col,
  Progress,
  Button,
  Drawer,
  Icon,
  Carousel,
  Dropdown,
  Menu,
} from 'ant-design-vue'
// main.js文件
// import printJS from 'print-js'

// Vue.prototype.$printJS = printJS

// main.js文件 导出pdf
import vueToPdf from 'vue-to-pdf'

const { source, campaign, media } = utm

Vue.use(vueToPdf)
Vue.config.productionTip = false

Vue.use(Row)
  .use(Col)
  .use(Progress)
  .use(Button)
  .use(Drawer)
  .use(Icon)
  .use(Carousel)
  .use(Dropdown)
  .use(Menu)

var sensors = require('sa-sdk-javascript')
sensors.init({
  server_url: 'https://sa.bongmi.com/sa?project=default',
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
  },
  // debug_mode: true,
  show_log: 'process.env.NODE_ENV' !== 'production',
})

sensors.registerPage({
  utm_source: source,
  utm_campaign: campaign,
  utm_media: media,
})

sensors.quick('autoTrack') //用于采集 $pageview 事件。

Vue.prototype.$sensors = sensors
Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')

document.addEventListener('visibilitychange', function () {
  if (document.visibilityState === 'hidden') {
    sensors.track('ExitQuestionnaire', {
      answerNumber: store.state.answerQsNumber,
    })
  }
})
